import clsx from 'clsx';
import React, { FC } from 'react';

export interface SpinnerProps {
  size?: number;
  spinnerStyle?: spinnerStyleEnum;
}

export enum spinnerStyleEnum {
  PRIMARY = 'primary',
  GRAY = 'gray'
}

export const Spinner: FC<SpinnerProps> = ({ size = 20, spinnerStyle = spinnerStyleEnum.PRIMARY }) => {
  const borderWidth = size / 10;

  return (
    <div
      className={clsx('spinner', spinnerStyle)}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderWidth: `${borderWidth}px`
      }}
      data-testid='spinner'
    >
      <span />
    </div>
  );
};
